import styled from 'styled-components';

export const NavContainer = styled.nav`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 0;
`

export const NavLeft = styled.div`
    display: flex;
    align-items: center;
`
export const NavRight = styled.div`
    display: flex;

`
export const NavProfile = styled.div`
    display: flex;
    gap: 0.5rem;
    align-items: center;
`
export const NavList = styled.ul`
    display: flex;
    list-style: none;
    align-items: center;
    gap: 1rem;
    padding-left: 1rem;
`

export const NavItem = styled.li`
    cursor: pointer;
`
export const NavLink = styled.a`
    text-decoration: none;
    color: inherit;
`
export const NavLogoImg = styled.img`
    width: 2.5rem;
`
export const NavProfileImg = styled.img`
    width: 1.5rem;
`